"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Spinner.scss");
var Join_1 = require("../../../helpers/Functions/Join");
var Spinner = function (_a) {
    var ariaLabel = _a.ariaLabel, children = _a.children, className = _a.className, style = _a.style, onDark = _a.onDark, testId = _a.testId;
    var svg = (React.createElement("svg", __assign({ viewBox: "0 0 43 43", className: Join_1.join([className, styles.loadingSpinner, "flex", "flex-items-center"], styles.loaderSvg, styles.loader), "arial-label": ariaLabel ? ariaLabel : '' }, (!children
        ? {
            style: style,
        }
        : {})),
        React.createElement("g", null,
            React.createElement("circle", { className: styles.loadingSpinnerInner, r: "20", cx: "21.5", cy: "21.5", fill: "none" }),
            React.createElement("circle", { className: styles.loadingSpinnerOuter, r: "20", cx: "21.5", cy: "21.5", fill: "none" }))));
    return children ? (React.createElement("div", { className: Join_1.join(className, styles.loader, "flex", "flex-items-center", "color-ui-dark-gray", onDark && "color-ui-gray"), "data-testid": testId, style: style },
        svg,
        React.createElement("span", { className: "type-sm-2 font-medium line-h-lg" }, children))) : (svg);
};
exports.default = Spinner;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Spinner/Spinner.js
// module id = 645
// module chunks = 8